<div class="container">
  <h2>Energy Credit Support</h2>
  <section>
    <table mat-table [dataSource]="data">
      <ng-container matColumnDef="task">
        <th mat-header-cell *matHeaderCellDef>Task</th>
        <td mat-cell *matCellDef="let element">{{ element.task }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button color="primary" (click)="element.action()">
            {{ element.buttonLabel }}
          </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </section>

  <section class="data-sync-section">
    <h3>Trigger ClaytonGO to NEXT Data Sync</h3>
    <div class="sync-controls">
      <mat-form-field appearance="outline">
        <mat-label>Facility</mat-label>
        <mat-select [(value)]="selectedFacility">
          @for (facility of facilities; track facility.Id) {
            <mat-option [value]="facility">
              {{ facility.KeyChain.LegacyId }} - {{ facility.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!selectedFacility"
        (click)="triggerClaytonGoToNextDataSync()"
      >
        Trigger
      </button>
    </div>
  </section>

  <section class="data-sync-section">
    <h3>Migrate Certificate Mailed Submissions</h3>
    <div class="sync-controls">
      <mat-form-field appearance="outline">
        <mat-label>Facility</mat-label>
        <mat-select [(value)]="selectedMigrationFacility">
          @for (facility of facilities; track facility.Id) {
            <mat-option [value]="facility">
              {{ facility.KeyChain.LegacyId }} - {{ facility.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!selectedMigrationFacility"
        (click)="migrateCertificateMailedSubmissions()"
      >
        Migrate
      </button>
    </div>
  </section>

  <section class="data-sync-section">
    <h3>Refresh Retailer</h3>
    <div class="sync-controls">
      <mat-form-field appearance="outline">
        <mat-label>Long Serial Number</mat-label>
        <input matInput [(ngModel)]="serialNumber" />
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!serialNumber.trim()"
        (click)="refreshRetailer()"
      >
        Refresh
      </button>
    </div>
  </section>

  <section class="data-sync-section">
    <h3>Resync Facility</h3>
    <div class="sync-controls">
      <mat-form-field appearance="outline">
        <mat-label>Facility</mat-label>
        <mat-select [(value)]="facilityToResync">
          @for (facility of facilities; track facility.Id) {
            <mat-option [value]="facility">
              {{ facility.KeyChain.LegacyId }} - {{ facility.Name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!facilityToResync"
        (click)="resyncFacility()"
      >
        Resync
      </button>
    </div>
  </section>
</div>
